import Cookie from 'js-cookie';

window.closeAlert = id => {
    $(`#alert${id}`).remove();

    const date = new Date();
    const minutes = 31536000;
    date.setTime(date.getTime() + minutes * 60 * 1000);

    Cookie.set(`alert${id}`, 1, {expires: date, path: '/', secure: false});
};
